import { render, staticRenderFns } from "./SignUpEmailConfirmCode.vue?vue&type=template&id=63ebda84&"
import script from "./SignUpEmailConfirmCode.vue?vue&type=script&lang=ts&"
export * from "./SignUpEmailConfirmCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports